import { genPopulateAttr } from '@utils/util';

export const generateUserAttributes = (): string => {
  const attributes = [
    ['role'],
    ['saved_jobs'],
    ['saved_schools'],
    ['saved_companies'],
    ['affiliated_company'],
    ['affiliated_school']
  ];

  return attributes.map(it => genPopulateAttr(it)).join('&');
};
